<template>
  <el-upload
    drag
    :class="`ly-upload ${admin}`"
    :auto-upload="false"
    :on-change="handleChange"
    :file-list="fileList"
    v-bind="$attrs"
    v-on="$listeners"
    :limit="1"
    action="''"
  >
    <div class="placeholder" v-if="fileList.length === 0">
      {{ $t("messages.plFile") }}
    </div>
    <el-button size="mini" plain @click="fileBtnClickEvent"
      >{{ $t("messages.btnFile") }} <i class="icon-FileArrowUp"
    /></el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    admin: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleChange(file, fileList) {
      this.$emit("handleChange", file, fileList);
    },

    fileBtnClickEvent : function () {
      this.$emit("fileBtnClickEvent");
    },
  },
};
</script>

<style lang="scss" scoped>
@charset "utf-8";
.ly-upload {
  position: relative;
  height: 28px;
  @include mobile {
    height: 48px;
  }
  ::v-deep {
    .el-upload {
      width: 100%;
      position: absolute;
      top: 0;
      &-list {
        position: absolute;
        top: 0;
        height: 100%;
        // z-index: -1;
        &__item {
          padding: 0 10px;

          &:first-child {
            margin-top: 0;
          }
          &-status-label {
            display: none;
          }
          .el-icon-document {
            display: none;
          }
          &:hover {
            background: transparent;
          }
        }
        .el-progress {
          width: 98%;
        }
      }
      &__tip {
        position: absolute;
        top: 50%;
        left: 6px;
        color: $--text-placeholder;
        font-size: $--font-size-table-small;
        transform: translateY(-50%);
      }
      .el-button--mini {
        position: absolute;
        top: 0;
        right: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 15px;
        border-color: $--color-button-upload;
        color: $--color-button-upload;
        width: 90px;
        padding: 0;
        font: {
          size: $--font-size-small;
          weight: $--font-weight-Medium;
        }
        @include mobile {
          width: 100px;
          height: 46px;
          line-height: 46px;
          font: {
            size: $--font-size-base;
          }
          i {
            font-size: $--font-size-medium;
          }
        }
      }
      &-dragger {
        position: absolute;
        left: 0;
        width: 100%;
        border: 0;
        height: 28px;
        background: transparent;
        border-radius: 0;
        @include mobile {
          height: 48px;
        }
        &::before {
          display: block;
          position: absolute;
          width: calc(100% - 100px);
          left: 0;
          right: 0;
          height: 26px;
          border: 1px solid $--color-light-gray {
            radius: 4px;
          }
          background: transparent;
          content: "";
          @include mobile {
            height: 46px;
            width: calc(100% - 110px);
          }
        }
      }
    }
  }
  .placeholder {
    display: block;
    position: absolute;
    left: 10px;
    font-size: $--font-size-small;
    color: $--text-placeholder;
    line-height: 26px;
    @include mobile {
      line-height: 46px;
    }
  }
  &.admin {
    height: 38px;
    ::v-deep {
      .el-upload {
        &-dragger {
          height: 36px;
          &::before {
            height: 34px;
          }
        }
      }
      .el-button--mini {
        height: 36px;
      }
    }
  }
}
</style>
